import React from 'react';
import { Masonry } from '@forgeglobal/design-framework';
import useMasonryDynamicColumns from '@tcs/common/hooks/useMasonryDynamicColumns';
import RepresentativeInfoCard from '@tcs/client-portal-common/components/templates/DetailCards/RepresentativeInfoCard';
import AddressCard from '@tcs/client-portal-common/components/templates/DetailCards/AddressCard';
import ContactInfoCard from '@tcs/client-portal-common/components/templates/DetailCards/ContactInfoCard';
import { Representative } from '@tcs/client-portal-api/types/Representative';

interface RepresentativeInfoProps {
  profile: Representative;
}

const RepresentativeInfo = ({ profile }: RepresentativeInfoProps) => {
  const dynamicColumns = useMasonryDynamicColumns('lg', 2);

  if (!profile) {
    return null;
  }

  const { representativeCode, name, firmName, contactInfo, address } = profile;

  return (
    <Masonry numCols={dynamicColumns}>
      <RepresentativeInfoCard
        representativeCode={representativeCode}
        name={name}
        firmName={firmName}
      />
      <AddressCard address={address} />
      <ContactInfoCard contactInfo={contactInfo} />
    </Masonry>
  );
};

export default RepresentativeInfo;
